import { Fragment, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { COUNTERPARTY_ACTION } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { ROUTE_PATHS } from 'routes/constants';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './CounterpartiesTableRow.scss';

const CounterpartiesTableRow = ({ isLoading, counterpartyData, handleChangeCounterPartyAction }) => {
  const i18n = useContext(i18nContext);

  const counterpartiesStatusesOptions = Object.keys(COUNTERPARTY_ACTION).map((key) => {
    return {
      key: COUNTERPARTY_ACTION[key],
      value: i18n.getMessage('counterpartyAction.' + COUNTERPARTY_ACTION[key])
    };
  });

  const changeCounterpartyAction = (name, value) => {
    handleChangeCounterPartyAction(counterpartyData.id, {
      action: value
    });
  };

  const getCounterpartyInfoBlock = (counterpartyBlockInfo, isAction, isAccountNumberSortCodeBic, isCounterpartyId) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'counterparties-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (isCounterpartyId) {
      return (
        <NavLink
          className={'counterparty-transaction-id-text'}
          to={`${ROUTE_PATHS.TRANSACTIONS}?search_text=${counterpartyBlockInfo}`}
        >
          {counterpartyBlockInfo}
        </NavLink>
      );
    } else if (Array.isArray(counterpartyBlockInfo)) {
      return (
        <p>
          {counterpartyBlockInfo.map((item, index) => {
            if (item) {
              return (
                <Fragment key={index}>
                  {item}
                  {index < counterpartyBlockInfo?.length - 1 && <br />}
                </Fragment>
              );
            }
          })}
        </p>
      );
    } else if (isAction) {
      return (
        <InputDropDown
          className={'counterparties-action-input-wrapper'}
          name={'action'}
          value={counterpartyData.action}
          options={counterpartiesStatusesOptions}
          onChange={changeCounterpartyAction}
        />
      );
    } else if (isAccountNumberSortCodeBic) {
      return (
        <>
          {counterpartyBlockInfo.accountNumber && (
            <p>
              <b>{i18n.getMessage('counterparties.table.rowContent.accountNumber')} </b>
              {counterpartyBlockInfo.accountNumber}
            </p>
          )}
          {counterpartyBlockInfo.sortCode && (
            <p>
              <b>{i18n.getMessage('counterparties.table.rowContent.sortCode')} </b>
              {counterpartyBlockInfo.sortCode}
            </p>
          )}
          {counterpartyBlockInfo.bic && (
            <p>
              <b>{i18n.getMessage('counterparties.table.rowContent.bic')} </b>
              {counterpartyBlockInfo.bic}
            </p>
          )}
        </>
      );
    } else {
      return <p>{counterpartyBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'counterparties-table-cell'}>
        {getCounterpartyInfoBlock(counterpartyData.counterpartyNumber, false, false, true)}
      </td>
      <td className={'counterparties-table-cell'}>
        {getCounterpartyInfoBlock(
          counterpartyData.internalCounterparty
            ? i18n.getMessage('counterparties.table.rowContent.internal')
            : i18n.getMessage('counterparties.table.rowContent.external')
        )}
      </td>
      <td className={'counterparties-table-cell'}>{getCounterpartyInfoBlock(counterpartyData.partyName)}</td>
      <td className={'counterparties-table-cell'}>{getCounterpartyInfoBlock(counterpartyData, false, true)}</td>
      <td className={'counterparties-table-cell'}>
        {getCounterpartyInfoBlock(i18n.getMessage(`counterpartyAction.${counterpartyData.action}`), true)}
      </td>
    </tr>
  );
};

CounterpartiesTableRow.propTypes = {
  isLoading: PropTypes.bool,
  counterpartyData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    counterpartyNumber: PropTypes.string.isRequired,
    internalCounterparty: PropTypes.bool.isRequired,
    partyName: PropTypes.string.isRequired,
    registrationNumber: PropTypes.string,
    accountNumber: PropTypes.string.isRequired,
    sortCode: PropTypes.string,
    bic: PropTypes.string,
    action: PropTypes.oneOf(['ALLOW', 'BLOCK', 'VERIFY', 'DO_NOTHING']).isRequired
  }),
  handleChangeCounterPartyAction: PropTypes.func
};

export default CounterpartiesTableRow;
